import React, { useEffect } from "react";
import Skeleton from '@mui/material/Skeleton';

function SkeletonDisplay() {
  return(
    <div>
      <div>
        <div className="flex flex-row divide-x divide-gray-300">
          {/* First column - 200px wide */}
          <div className="flex flex-col w-[200px] divide-y divide-gray-200">
            <div className="flex flex-col justify-center items-center h-[110px] p-2">
              <div className="w-full">
                <Skeleton variant="text" sx={{ fontSize: '1.4rem' }} width={100} />
              </div>
              <div className="w-full flex items-center gap-2">
                <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} width={60} />
                <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} width={30} />
                <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} width={60} />
              </div>
              <div className="w-full">
                <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} width={"100%"} />
              </div>
            </div>
            <div className="flex justify-center items-center h-[44px] p-2">
              <Skeleton variant="rounded" width={"100%"} height={"100%"} />
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 p-2" style={{ height: "60px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <div className="flex-1">
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={120} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={60} />
              </div>
            </div>
          </div>

          {/* Remaining columns - flex-1 */}
          {[...Array(7)].map((_, index) => (
            <div key={index} className="flex flex-col flex-1 divide-y divide-gray-200">
              <div className="flex flex-col justify-center items-center h-[110px] p-2">
                <div className="flex items-center justify-between w-full">
                  <Skeleton variant="text" sx={{ fontSize: '1.4rem' }} width={"60%"} />
                  <Skeleton variant="text" sx={{ fontSize: '1.4rem' }} width={"20%"} />
                </div>
                <div className="flex items-center justify-between w-full">
                  <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} width={"35%"} />
                  <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} width={"35%"} />
                </div>
                <div className="flex items-center justify-between w-full">
                  <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} width={"35%"} />
                  <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} width={"35%"} />
                </div>
              </div>
              <div className="flex justify-center items-center h-[44px] p-2">
                <Skeleton variant="rounded" width={"100%"} height={"100%"} />
              </div>
              {[...Array(14)].map((_, rowIndex) => (
                <div key={rowIndex} className="flex justify-center items-center h-[60px] p-2">
                  <Skeleton variant="rounded" width={"100%"} height={"100%"} />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default SkeletonDisplay
